import SaveIcon from "@mui/icons-material/Save";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { Box, TextField, Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import * as Styled from "./FilterSearchField.styles";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { AppRemoveIcon } from "../../Icon/AppRemoveIcon";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

 interface IFilterDialogFilterRowItem extends IIdTitle {
    getIsShared(): boolean;
    getIsUserLevel(): boolean;
}

interface FilterSearchFieldProps {
    filter: IFilterDialogFilterRowItem;
    canRemoveSharedFilters: boolean;
    isReport?: boolean;
    onSaveFilter: (saveAs: boolean) => void;
    onRemoveFilter: (filterId: string) => void;
}

export const FilterSearchField = ({ filter, canRemoveSharedFilters, isReport, onSaveFilter, onRemoveFilter }: FilterSearchFieldProps) => {
    return (
        <Box display="flex" alignItems="center">
            <TextField disabled value={filter?.getTitle() ?? ""} size="small" fullWidth InputProps={{
                endAdornment: (
                    <Styled.ButtonGroup>
                        {filter?.getIsUserLevel() && (!filter?.getIsShared() || canRemoveSharedFilters) &&
                            <Tooltip title={isReport ? Translations.SaveReport : Translations.SaveFilter}>
                                <AppButton variant="outlined" onClick={() => onSaveFilter(false)}><SaveIcon /></AppButton>
                            </Tooltip>
                        }
                        {!!onSaveFilter &&
                            <Tooltip title={isReport ? Translations.SaveReportAs : Translations.SaveFilterAs}>
                                <AppButton variant="outlined" onClick={() => onSaveFilter(true)}><SaveAsIcon /></AppButton>
                            </Tooltip>
                        }
                        {!!onRemoveFilter && filter?.getIsUserLevel() && (!filter?.getIsShared() || canRemoveSharedFilters) &&
                            <Tooltip title={isReport ? Translations.RemoveReport : Translations.RemoveFilter}>
                                <AppButton variant="outlined" onClick={() => onRemoveFilter(filter?.id)}><AppRemoveIcon /></AppButton>
                            </Tooltip>
                        }
                    </Styled.ButtonGroup>
                )
            }} />
        </Box>
    );
};
